// extracted by mini-css-extract-plugin
export var card = "_mv-1";
export var summary = "_mv-0";